import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api, { fmtErr } from "../api";
import { Eye, EyeSlash } from "@phosphor-icons/react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return setErr("Password must be at least 8 characters");
    if (pw !== pw2) return setErr("Passwords don't match");
    setBusy(true); setErr("");
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      setDone(true);
    } catch (e2) { setErr(fmtErr(e2)); }
    setBusy(false);
  };

  return (
    <div className="mx-auto flex min-h-screen max-w-lg flex-col justify-center bg-background p-6">
      <div className="mb-6 flex items-center gap-3">
        <img src="/veloktify-icon.svg" alt="Veloktify" className="h-10 w-10 rounded-lg" />
        <h1 className="font-heading text-2xl font-bold tracking-tight" data-testid="reset-title">Set a new password</h1>
      </div>
      {!token && !done && (
        <p data-testid="reset-no-token" className="card-flat p-4 text-sm font-semibold text-destructive">
          This link is missing its token — use the full link from your email.
        </p>
      )}
      {done ? (
        <div className="card-flat space-y-4 p-6" data-testid="reset-success">
          <p className="text-sm font-semibold text-primary">Password updated. You can sign in with it now.</p>
          <Link to="/login" data-testid="reset-login-link" className="btn-primary-big flex !h-14 items-center justify-center !text-base">Go to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="card-flat space-y-4 p-6" data-testid="reset-form">
          <div className="relative">
            <input data-testid="reset-password-input" type={showPw ? "text" : "password"} className="field-input w-full pr-12" placeholder="New password (8+ characters)"
              value={pw} onChange={(e) => setPw(e.target.value)} required />
            <button type="button" data-testid="reset-toggle-pw" onClick={() => setShowPw(!showPw)} aria-label="Show password"
              className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground">
              {showPw ? <EyeSlash size={20} /> : <Eye size={20} />}
            </button>
          </div>
          <input data-testid="reset-password-confirm" type={showPw ? "text" : "password"} className="field-input w-full" placeholder="Confirm new password"
            value={pw2} onChange={(e) => setPw2(e.target.value)} required />
          {err && <p data-testid="reset-error" className="text-sm font-semibold text-destructive">{err}</p>}
          <button data-testid="reset-submit" disabled={busy || !token} className="btn-primary-big !h-14 !text-base disabled:opacity-40">
            {busy ? "Saving…" : "Save password"}
          </button>
        </form>
      )}
    </div>
  );
}
